"use client";

import { SessionProvider } from "next-auth/react";
import { HomeChat } from "./home-chat";

export function ChatWrapper() {
  return (
    <SessionProvider>
      <div className="h-full w-full">
        <HomeChat />
      </div>
    </SessionProvider>
  );
}
